import { createContext, useContext } from 'react';
import type { OrderService } from '@mypoz/shared';

export interface OrderServicesState {
  /** Every warehouse add-on service (`order_services`), one entry per warehouse and service id. */
  readonly services: readonly OrderService[];
  readonly status: 'loading' | 'ready' | 'error';
  /** Asks the vendor again. Safe to call at any time; a fetch already in flight is discarded. */
  reload: () => void;
}

export const OrderServicesContext = createContext<OrderServicesState | null>(null);

export function useOrderServices(): OrderServicesState {
  const value = useContext(OrderServicesContext);
  if (!value) throw new Error('useOrderServices must be used inside OrderServicesProvider');
  return value;
}
